import { IRowAction } from 'core-components/library/list/types'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS } from '../../../configs/translations'
import { IBusinessPriority } from '../../../model/types'
import { RowAction } from '../../rowAction'

const KEYS = BUSINESS_PRIORITIES_TRANSLATION_KEYS

interface IGetRowActionsParams {
  market?: string
  onEdit: (item: IBusinessPriority) => void
  onDelete: (item: IBusinessPriority) => void
  onSwitchOn: (item: IBusinessPriority) => void
  onSwitchOff: (item: IBusinessPriority) => void
  onActivate: (item: IBusinessPriority) => void
  onDeactivate: (item: IBusinessPriority) => void
}

export const getRowActions = ({
  market = '',
  onEdit,
  onDelete,
  onSwitchOn,
  onSwitchOff,
  onActivate,
  onDeactivate,
}: IGetRowActionsParams): IRowAction<IBusinessPriority>[] => {
  const editAction: IRowAction<IBusinessPriority> = {
    id: 'edit',
    action: onEdit,
    isVisible: (record) => record.availableActions.includes('edit'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`edit-${item.name}`}
        text={KEYS.table.actionEdit}
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  const deleteAction: IRowAction<IBusinessPriority> = {
    id: 'delete',
    action: onDelete,
    isVisible: (record) => record.availableActions.includes('delete'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`delete-${item.name}`}
        text={KEYS.table.actionDelete}
        color="danger"
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  const switchOff: IRowAction<IBusinessPriority> = {
    id: 'switchOff',
    action: onSwitchOff,
    isVisible: (record) => record.availableActions.includes('turnoff'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`switch-off-${item.name}`}
        text={KEYS.table.actionSwitchOffForMarket}
        market={market}
        color="danger"
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  const switchOn: IRowAction<IBusinessPriority> = {
    id: 'switchOn',
    action: onSwitchOn,
    isVisible: (record) => record.availableActions.includes('turnon'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`switch-on-${item.name}`}
        text={KEYS.table.actionSwitchOnForMarket}
        market={market}
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  const deactivateAction: IRowAction<IBusinessPriority> = {
    id: 'deactivate',
    action: onDeactivate,
    isVisible: (record) => record.availableActions.includes('deactivate'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`deactivate-${item.name}`}
        text={KEYS.table.actionDeactivate}
        color="danger"
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  const activateAction: IRowAction<IBusinessPriority> = {
    id: 'activate',
    action: onActivate,
    isVisible: (record) => record.availableActions.includes('activate'),
    customView: ({ item, isDisabled, action }) => (
      <RowAction
        key={`activate-${item.name}`}
        text={KEYS.table.actionActivate}
        isDisabled={isDisabled}
        action={action}
      />
    ),
  }

  return [switchOff, switchOn, editAction, activateAction, deactivateAction, deleteAction]
}
